import { CrewMemberExt } from '@bechtel/client-common';

export interface CrewChangeSummaryProps {
  sourceCrewMembers: CrewMemberExt[];
  destinationCrewMembers: CrewMemberExt[];
}
